import { UserSubscriptionPlanSummary } from './constants';

// a filter predicate for only showing the plans we want users manage
// on manage subscriptions page
export const filterUserSubscriptionPlansManage = (
  plan: UserSubscriptionPlanSummary
): boolean => {
  if (plan.type === 'educator' && !plan.isActive) {
    return false;
  }

  return true;
};
